import { useFetch, inr } from "../lib/api";
import { PageHeader, Pill, Empty } from "../components/shared";

const TONE = { FILED: "green", PENDING: "amber", OVERDUE: "red" };
const CHECK = { MATCH: ["green", "Matches"], MISMATCH: ["red", "Mismatch"], NO_CHALLAN: ["slate", "No challan"] };

export const FilingsTable = ({ rows }) => (
  <div className="c-surface overflow-x-auto c-rise">
    <table className="c-table w-full">
      <thead><tr><th>Month</th><th>Type</th><th>Workers</th><th>Due</th><th>Paid</th><th>Due date</th><th>Status</th><th>Challan check</th><th>Challan no.</th></tr></thead>
      <tbody>{rows.map((r) => (
        <tr key={r.type + r.month} data-testid="my-filing-row">
          <td className="font-mono text-xs">{r.month}</td><td>{r.type}</td><td>{r.workers}</td>
          <td className="font-mono text-xs">{inr(r.amount_due)}</td><td className="font-mono text-xs">{inr(r.amount_paid)}</td>
          <td className="font-mono text-xs">{r.due_date}</td>
          <td><Pill tone={TONE[r.status]} testid="my-filing-status">{r.status}{r.filed_on ? ` · ${r.filed_on}` : ""}</Pill></td>
          <td>{r.check ? <span title={r.check.status === "MISMATCH" ? `Difference ${inr(r.check.difference)}` : ""}><Pill tone={CHECK[r.check.status][0]}>{CHECK[r.check.status][1]}</Pill></span> : <span className="text-xs text-slate-500">—</span>}</td>
          <td className="font-mono text-xs">{(r.challan_numbers || []).join(", ") || "—"}</td>
        </tr>))}</tbody>
    </table>
  </div>);

export default function MyFilings() {
  const { data } = useFetch("/pe/my-filings");
  return (
    <div data-testid="my-filings-page">
      <PageHeader eyebrow="Contractor" title="My statutory filings" desc="Your PF and ESIC dues for the last 12 months, what has been paid, and whether each challan matches the ECR / ESIC file built from your wages. Due on the 15th of the following month." />
      {!data ? <p className="text-xs text-slate-500 font-mono">Loading…</p> : <>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
          {[["Filed", data.filed, "text-emerald-300"], ["Pending", data.pending, "text-amber-300"], ["Overdue", data.overdue, "text-rose-300"],
            ["CLRA licence", data.clra_license_expiry ? `till ${data.clra_license_expiry}` : "—", "text-white"]].map(([l, v, c]) => (
            <div key={l} className="c-surface p-4 c-rise" data-testid={`my-filings-${l.toLowerCase().replace(/\s/g, "-")}`}>
              <div className="text-xs text-slate-400">{l}</div><div className={`font-display text-2xl font-semibold mt-1 ${c}`}>{v}</div></div>))}
        </div>
        {data.open_hold && <div className="mb-4 rounded-lg border border-rose-500/40 bg-rose-500/10 px-4 py-2.5 text-sm text-rose-100" data-testid="my-filings-hold">
          Payment on hold for {data.open_hold.billing_month} ({data.open_hold.reason_code}). Upload the missing or corrected challan to clear it.</div>}
        {!data.rows.length ? <Empty text="No PF or ESIC dues yet — enter wages to see your filings." /> : <FilingsTable rows={data.rows} />}
      </>}
    </div>);
}
